export class LoginPessoa {

   cpf: string;
   senha: string;

}



// WEBPACK FOOTER //
// ./src/app/models/login-pessoa.ts